export default "/assets/images/performance-filter-img-02.b1dd2402b28ed3de.png";